import numbro from 'numbro';

import {
	EasyClaimCustomerConfigurationDto,
	ProductType,
} from './easyclaim.api.client.typescript/src';

export const SelectNumbersFormat = (_configuration: EasyClaimCustomerConfigurationDto) => {
	let cultureInfo: string;
	let language: numbro.NumbroLanguage;

	if (
		_configuration.companyShortName?.trim().toLocaleLowerCase() === 'allianzpt' &&
		_configuration.layout === ProductType.EasyClaim
	) {
		cultureInfo = 'pt-PT';
		language = require(`numbro/dist/languages/${cultureInfo}.min`) as numbro.NumbroLanguage;

		language.currencyFormat!.thousandSeparated = true;
		language.currencyFormat!.mantissa = 2;
		language.currencyFormat!.totalLength = 0;
		language.delimiters.thousands = '.';
		language.currencyFormat!.average = false;
	} else {
		cultureInfo = 'pl-PL';
		language = require(`numbro/dist/languages/${cultureInfo}.min`) as numbro.NumbroLanguage;

		/* override default currency format */
		language.currencyFormat!.spaceSeparated = true;
		language.currencyFormat!.thousandSeparated = true;
		language.currencyFormat!.mantissa = 2;
		language.currencyFormat!.totalLength = 0;
	}
	numbro.registerLanguage(language);
	numbro.setLanguage(cultureInfo);
};
